import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Initialize Google Analytics
const initGA = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "G-Q0FTY03GT3");
  window.gtag = gtag;
};

// Load Google Analytics script
const loadGA = () => {
  const script = document.createElement("script");
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-Q0FTY03GT3";
  script.async = true;
  document.head.appendChild(script);
};

// Track scroll depth
const trackScrollDepth = () => {
  let maxScroll = 0;
  let scrollTimeout;

  window.addEventListener("scroll", () => {
    const scrollPercent = Math.round(
      ((window.scrollY + window.innerHeight) /
        document.documentElement.scrollHeight) *
        100
    );

    // Track at 25%, 50%, 75%, and 100% scroll depth
    if (scrollPercent >= 25 && maxScroll < 25) {
      window.gtag("event", "scroll_depth", {
        event_category: "engagement",
        event_label: "25%",
      });
      maxScroll = 25;
    } else if (scrollPercent >= 50 && maxScroll < 50) {
      window.gtag("event", "scroll_depth", {
        event_category: "engagement",
        event_label: "50%",
      });
      maxScroll = 50;
    } else if (scrollPercent >= 75 && maxScroll < 75) {
      window.gtag("event", "scroll_depth", {
        event_category: "engagement",
        event_label: "75%",
      });
      maxScroll = 75;
    } else if (scrollPercent >= 90 && maxScroll < 90) {
      window.gtag("event", "scroll_depth", {
        event_category: "engagement",
        event_label: "90%",
      });
      maxScroll = 90;
    }
  });
};

// Track site search
const trackSiteSearch = () => {
  // Track search form submissions
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (form.getAttribute("data-search-form") === "true") {
      const searchInput = form.querySelector('input[type="search"]');
      if (searchInput) {
        window.gtag("event", "search", {
          event_category: "engagement",
          search_term: searchInput.value,
        });
      }
    }
  });
};

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Load GA script
    loadGA();
    // Initialize GA
    initGA();
    // Initialize scroll tracking
    trackScrollDepth();
    // Initialize search tracking
    trackSiteSearch();
  }, []);

  useEffect(() => {
    // Track page views when route changes
    if (window.gtag) {
      window.gtag("config", "G-Q0FTY03GT3", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default Analytics;
